import gql from 'graphql-tag';

import type { ReviewerProjectListItem } from 'src/data/project';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors, unwrapEdges } from 'src/lib/graphql';
import type { BackendPageInfo, BackendQueryReviewerProjectsArgs } from 'src/types/backend';

const PAGE_SIZE = 20;

const QUERY = gql`
  query ReviewerProjects($customerId: ID!, $after: String) {
    reviewerProjects(customerId: $customerId, first: ${PAGE_SIZE}, after: $after) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

type Variables = Pick<BackendQueryReviewerProjectsArgs, 'customerId' | 'after'>;
interface Result {
  edges: { node: ReviewerProjectListItem }[];
  pageInfo: Pick<BackendPageInfo, 'endCursor' | 'hasNextPage'>;
}

/** The projects shared with the current user in a reviewer account, the newest share first. */
export const queryReviewerProjects = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);
  const connection = getSingleProp<Result>(result.data);
  return {
    projects: unwrapEdges(connection?.edges),
    pageInfo: connection?.pageInfo ?? { endCursor: null, hasNextPage: false },
  };
};
